module.exports =
  on: ->
    EventsBus.$emit('switch-loader', true)

  off: ->
    EventsBus.$emit('switch-loader', false)



// WEBPACK FOOTER //
// ./src/libraries/loader.coffee